<template>
	<div class="d-flex flex-column flex-root">
		<!--begin::Login-->
		<div
			class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
			id="kt_login"
		>
			<!--begin::Aside-->
			<div class="login-aside d-flex flex-column flex-row-auto" style="background-color: #F2C98A;">
				<!--begin::Aside Top-->
				<div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
					<!--begin::Aside header-->
					<a href="#" class="text-center mb-10">
						<img src="assets/media/logos/logo-letter-1.png" class="max-h-70px" alt />
					</a>
					<!--end::Aside header-->
					<!--begin::Aside title-->
					<h3
						class="font-weight-bolder text-center font-size-h4 font-size-h1-lg"
						style="color: #986923;"
					>
						Discover Amazing Metronic
						<br />with great build tools
					</h3>
					<!--end::Aside title-->
				</div>
				<!--end::Aside Top-->
				<!--begin::Aside Bottom-->
				<div
					class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
					style="background-image: url(assets/media/svg/illustrations/login-visual-1.svg)"
				></div>
				<!--end::Aside Bottom-->
			</div>
			<!--begin::Aside-->
			<!--begin::Content-->
			<div
				class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
			>
				<router-view></router-view>
				<!--begin::Content footer-->
				<div
					class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0"
				>
					<!-- <a href="#" class="text-primary font-weight-bolder font-size-h5">Terms</a>
					<a href="#" class="text-primary ml-10 font-weight-bolder font-size-h5">Plans</a>
					<a href="#" class="text-primary ml-10 font-weight-bolder font-size-h5">Contact Us</a>-->
				</div>
				<!--end::Content footer-->
			</div>
			<!--end::Content-->
		</div>
		<!--end::Login-->
	</div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
	@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
	import { mapState } from "vuex";

	export default {
		name: "auth",
		methods: {},
		computed: {
			...mapState({
				errors: (state) => state.auth.errors,
			}),
			backgroundImage() {
				return process.env.BASE_URL + "media/bg/bg-4.jpg";
			},
		},
	};
</script>
